import css from './sass/style.scss';

require('./js/anims')
require('./js/carousels')
require('./js/contact-form')
require('./js/filters')
require('./js/flash')
require('./js/fonts')
require('./js/glightbox')
require('./js/init')
require('./js/lazy')
require('./js/nav')
require('./js/polyfills')
//require('./js/sectionsnav')
require('./js/smoothscroll')
require('./js/tabs')
require('./js/map')
require('./js/cookieconsent')
require('./js/faq')
